import React from "react";
import { Typography, Box } from "@mui/material";
import DialogLayout from "../../DialogLayout";
import { useTailwindBrand } from "../../../Theme/useTailwindBrand";
import { pictureProgress } from "../../../Utils/Images";
import type { OnboardingStep } from "../../../Hooks/Dashboard/useHome";

interface RemainingStepsDialogProps {
  open: boolean;
  onClose: () => void;
  currentLevelNum: number;
  currentLevel?: { name: string; emoji: string };
  incompleteSteps: OnboardingStep[];
}

const RemainingStepsDialog: React.FC<RemainingStepsDialogProps> = ({
  open,
  onClose,
  currentLevelNum,
  currentLevel,
  incompleteSteps,
}) => {
  const { brandConfig, classes } = useTailwindBrand();

  return (
    <DialogLayout
      open={open}
      handleClose={onClose}
      title={`⏳ Étapes restantes pour le Niveau ${currentLevelNum} : ${currentLevel ? `${currentLevel.name} ${currentLevel.emoji}` : "actuel"}`}
      text={null}
      maxWidth="md"
    >
      <Box sx={{ display: "flex", gap: 2 }} className="flex items-center">
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ fontFamily: brandConfig.fontFamily }}>
            Complétez les étapes suivantes pour débloquer votre récompense :
          </Typography>
          {incompleteSteps.map((step) => {
            const sub = step.subSteps;
            return (
              <Box
                key={step.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1.5,
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: "divider",
                  bgcolor: brandConfig.colors.accent + "1A",
                }}
              >
                <Box
                  sx={{
                    flexShrink: 0,
                    width: 40,
                    height: 40,
                    borderRadius: 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "white",
                    color: "grey.600",
                    "& .MuiSvgIcon-root": { fontSize: 22 },
                  }}
                >
                  {step.icon}
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    variant="subtitle2"
                    className="font-bold"
                    sx={{ fontFamily: brandConfig.fontFamily, color: brandConfig.colors.primary }}
                  >
                    {step.title}
                  </Typography>
                  {sub && (
                    <Typography variant="caption" className={classes.text} sx={{ fontFamily: brandConfig.fontFamily }}>
                      {sub.completed}/{sub.total} complété{sub.total > 1 ? "s" : ""}
                    </Typography>
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>
        <Box
          sx={{
            width: { xs: 0, sm: 360 },
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "grey.50",
            borderRadius: 2,
            userSelect: "none",
          }}
        >
          <img src={pictureProgress} alt="image_progress" />
        </Box>
      </Box>
    </DialogLayout>
  );
};

export default RemainingStepsDialog;
